import { DestroyRef, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { ScreenType } from "backend/model/screenType";
import { APTContext } from "src/app/services/aptContext/apt-context";
import { pollForReady } from "src/standard/services/poll-for-ready";
import { StandardConfirmationDialogRequest } from "src/standard/standard-confirmation-dialog/standard-confirmation-dialog.types";
import { ModalDialogService } from "src/standard/standard-modal-button/showModalDialog";

export const PAGE_NOT_FOUND_DIALOG_CONFIG: StandardConfirmationDialogRequest = {
  message: $localize`Page not found.`,
  variant: "blocking",
};

export function ModuleEnabledGuard(screenType: ScreenType): CanActivateFn {
  return async (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const aptContext = inject(APTContext);
    const destroyRef = inject(DestroyRef);
    const modalDialogService = inject(ModalDialogService);

    await pollForReady(
      () => Object.keys(aptContext.engagementSettings() ?? {}).length > 0,
      destroyRef,
    );

    if (
      screenType === ScreenType.EvaluateControlsScreen &&
      aptContext.isControlModuleEnabled()
    ) {
      return true;
    }

    if (
      screenType === ScreenType.RiskandResponseScreen &&
      aptContext.isRiskModuleEnabled()
    ) {
      return true;
    }

    if (screenType === ScreenType.Points && aptContext.isPointModuleEnabled()) {
      return true;
    }

    await modalDialogService.showConfirmationDialog(
      PAGE_NOT_FOUND_DIALOG_CONFIG,
    );

    return router.navigate([`/ws/${aptContext.engagementId()}`]);
  };
}
